import type { AuthTheme } from '@/domain/models/auth.js';
import type { ThemeColors } from '@/domain/models/theme.js';

export function applyAuthTheme(
    theme: AuthTheme | null | undefined,
    applyClientTheme: (colors: ThemeColors | null, logoUrl: string | null) => void,
    resetToDefaultTheme: () => void
): void {
    if (theme?.colors || theme?.logoUrl) {
        applyClientTheme(theme.colors, theme.logoUrl);
        return;
    }
    resetToDefaultTheme();
}
